import { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

function useDeleteProgram() {
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const deleteProgram = async (programId: number) => {
        try {
            const response = await axios(`${baseUrl}/program/${programId}`, {
                method: 'DELETE',
                headers: {
                  'Content-Type':'application/json',
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });

            return response.status;
            
        } catch (error) {
            console.error(error);
        }
    };

    return { deleteProgram };
}

export default useDeleteProgram;
